// extracted by mini-css-extract-plugin
export default {"root":"AnswerList_root__SwBtP","empty":"AnswerList_empty__kiy0n"};